(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-custom-lure-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-mm-upload]');

    roots.forEach((root) => {
      if (root.dataset.uploadInitialized === 'true') return;
      root.dataset.uploadInitialized = 'true';

      const input = root.querySelector('.mm-custom-lure__upload-input');
      const status = root.querySelector('[data-upload-status]');
      const preview = root.querySelector('[data-upload-preview]');
      const previewImage = root.querySelector('[data-upload-preview-image]');
      const fileNameText = root.querySelector('[data-upload-filename]');
      const removeButton = root.querySelector('[data-upload-remove]');
      const urlField = root.querySelector('[data-upload-url]');
      const nameField = root.querySelector('[data-upload-file-name]');
      const form = root.closest('form');
      const cloudName = root.dataset.cloudName;
      const uploadPreset = root.dataset.uploadPreset;
      let objectUrl = '';
      let uploading = false;

      const setStatus = (message, type = '') => {
        status.textContent = message;
        status.classList.remove('is-error', 'is-success');
        if (type) status.classList.add(type);
      };

      const clearPreview = () => {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = '';
        input.value = '';
        preview.hidden = true;
        previewImage.removeAttribute('src');
        fileNameText.textContent = '';
        urlField.value = '';
        nameField.value = '';
        setStatus('');
      };

      const uploadFile = async (file) => {
        if (!cloudName || !uploadPreset) {
          setStatus('Image upload is not configured yet. Store owner: add the Cloudinary cloud name and unsigned upload preset in this section settings.', 'is-error');
          return;
        }

        if (!file.type.startsWith('image/')) {
          setStatus('Please choose an image file.', 'is-error');
          return;
        }

        if (file.size > 10 * 1024 * 1024) {
          setStatus('Please choose an image smaller than 10 MB.', 'is-error');
          return;
        }

        if (objectUrl) URL.revokeObjectURL(objectUrl);
        objectUrl = URL.createObjectURL(file);
        previewImage.src = objectUrl;
        fileNameText.textContent = file.name;
        preview.hidden = false;
        urlField.value = '';
        nameField.value = file.name;
        uploading = true;
        setStatus('Uploading image...');

        const body = new FormData();
        body.append('file', file);
        body.append('upload_preset', uploadPreset);
        body.append('folder', 'mm-custom-lure-requests');

        try {
          const response = await fetch(`https://api.cloudinary.com/v1_1/${encodeURIComponent(cloudName)}/image/upload`, {
            method: 'POST',
            body
          });
          const data = await response.json();

          if (!response.ok || !data.secure_url) {
            throw new Error(data?.error?.message || 'Upload failed');
          }

          urlField.value = data.secure_url;
          nameField.value = file.name;
          setStatus('Image uploaded successfully. It will be included with your request.', 'is-success');
        } catch (error) {
          urlField.value = '';
          setStatus(`Image upload failed: ${error.message}. Please try again.`, 'is-error');
        } finally {
          uploading = false;
        }
      };

      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (file) uploadFile(file);
      });

      removeButton.addEventListener('click', clearPreview);

      if (form) {
        form.addEventListener('submit', (event) => {
          if (uploading) {
            event.preventDefault();
            setStatus('Please wait for the image to finish uploading before submitting.', 'is-error');
            return;
          }

          if (input.files && input.files.length > 0 && !urlField.value) {
            event.preventDefault();
            setStatus('The selected image has not uploaded successfully yet. Please retry or remove it before submitting.', 'is-error');
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
